export default "__VITE_PUBLIC_ASSET__7c6b667d__"